import { render, staticRenderFns } from "./Corona.vue?vue&type=template&id=146b27f0&"
import script from "./Corona.vue?vue&type=script&lang=js&"
export * from "./Corona.vue?vue&type=script&lang=js&"
import style0 from "./Corona.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports